@let valueValue = value();

@for (item of items; track item.value) {
  <div
    class="boolean-field__option"
    [class.boolean-field__option--selected]="valueValue === item.value"
    (click)="select(item.value)"
  >
    <rt-radio
      [checked]="valueValue === item.value"
      (click)="$event.stopPropagation(); select(item.value)"
    >
      <span class="boolean-field__option-title">{{ item.option }}</span>
    </rt-radio>
  </div>
}
